/*
 *
 * */

import FilterFactory from '@/lib/filterFactory';

export default class ShopsFilter {
    filterHandlers = {
        update: 'clinicsFilter/updateFilter',
        reset: 'clinicsFilter/resetFilter',
        resetState: 'clinicsFilter/resetFilterState',
        removeSelected: 'clinicsFilter/removeSelectedFilter',
    };
    filterModel: Record<string, any>;

    constructor() {
        const filter = new FilterFactory();

        filter.createSearchEntity('title');
        filter.setPlaceholder('title', 'По названию');
        filter.setName('title', 'search_title');
        filter.setPreviewName('title', 'Название');
        filter.setClassName('title', 'col-1-row-1');
        filter.setIconClassName('title', 'icon-store');
        filter.setAction('title', 'clinicsFilter/updateSearch');

        filter.createSearchEntity('address');
        filter.setPlaceholder('address', 'По адресу');
        filter.setName('address', 'search_fullMarketName');
        filter.setPreviewName('address', 'Адрес');
        filter.setClassName('address', 'col-1-row-2');
        filter.setIconClassName('address', 'icon-compass');
        filter.setAction('address', 'clinicsFilter/updateSearch');

        filter.createCheckboxEntity('withInactive');
        filter.setName('withInactive', 'checkbox_activity');
        filter.setIconClassName('withInactive', 'icon-check-mark');
        filter.setPreviewName('withInactive', 'Неактив');
        filter.setClassName('withInactive', 'col-1-row-3');
        filter.setCheckboxList('withInactive', [
            {
                id: '0',
                name: 'Показывать деактивированные',
                value: 'withInactive',
                checked: false,
            }
        ]);
        filter.setAction('withInactive', 'clinicsFilter/updateCheckbox');

        this.filterModel = filter.filterModel;
    }
}
